import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  description: {
    required,
  },
  order: {
    required,
  },
};

export default validations;